import PreguntaConfirmacionActions from "./PreguntaConfirmacionActions";

const PreguntaConfirmacionRow = ({ pregunta, search }) => {
  const highlightText = (text) => {
    if (!search || search.length < 3) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };

  return (
    <tr>
      <td>{pregunta.id}</td>
      <td
        dangerouslySetInnerHTML={{
          __html: highlightText(pregunta.pregunta || "-"),
        }}
      />
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            pregunta.is_active
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {pregunta.is_active ? "Activa" : "Inactiva"}
        </span>
      </td>
      <td>
        {pregunta.created_at
          ? new Date(pregunta.created_at).toLocaleDateString("es-MX", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })
          : "-"}
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <PreguntaConfirmacionActions pregunta={pregunta} />
        </span>
      </td>
    </tr>
  );
};

export default PreguntaConfirmacionRow;
